// Google Maps' current JS API uses IntersectionObserver internally, and Zone.js's
// patched IntersectionObserver breaks it ("Failed to execute 'observe' on
// 'IntersectionObserver': parameter 1 is not of type 'Element'") on the map pages
// that still use @agm/core (create-zone, location-map, add-restaurant,
// add-driver-management). Disabling the patch for this one API is the standard,
// scoped fix — see the comment block in polyfills.ts for the full flag list.
(window as any).__Zone_disable_IntersectionObserver = true;
